// extracted by mini-css-extract-plugin
export var deleteModal = "_iw-0";